export default __webpack_public_path__ + "img/catIcon297.114f0361.svg";